import { render, staticRenderFns } from "./EventDetailsTimeslot.vue?vue&type=template&id=df1be840&scoped=true&"
import script from "./EventDetailsTimeslot.vue?vue&type=script&lang=ts&"
export * from "./EventDetailsTimeslot.vue?vue&type=script&lang=ts&"
import style0 from "./EventDetailsTimeslot.vue?vue&type=style&index=0&id=df1be840&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df1be840",
  null
  
)

export default component.exports